import { render, staticRenderFns } from "./Tool.vue?vue&type=template&id=4284dbe2&scoped=true"
import script from "./Tool.vue?vue&type=script&lang=js"
export * from "./Tool.vue?vue&type=script&lang=js"
import style0 from "./Tool.vue?vue&type=style&index=0&id=4284dbe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284dbe2",
  null
  
)

export default component.exports